import React, {Component} from "react";
import {HashRouter as Router, Route, Switch} from "react-router-dom";
import {ToastProvider} from 'react-toast-notifications';

import "./App.css";

import NavBar from "./components/common/NavBar";
import Footer from "./components/common/Footer";
import Create from "./pages/Create";
import Farm from "./pages/Farm";
import Home from "./pages/Home";
import MyNFTs from "./pages/MyNFTs";
import Events from "./pages/Events";
import NotFound from "./pages/NotFound";
import AlertDismissible from "./components/common/AlertDismissible";

import {ContractsContext, Web3Context} from "./contexts/Context";

import getWeb3 from "./getWeb3";

import NiftyEggsFarmer from "./contracts/NiftyEggsFarmer";
import NiftyEggsERC721 from "./contracts/NiftyEggsERC721";
import NiftyEggsERC20 from "./contracts/NiftyEggsERC20";
import Faucet from "./contracts/Faucet";

import Logger from "./components/utils/Logger";

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showAlert: false,
      web3: null,
      networkId: null,
      accounts: null,
      activeAccount: null,
      contractNiftyEggsFarmer: null,
      contractNiftyEggsERC721: null,
      contractNiftyEggsERC20: null,
      contractFaucet: null,
      nameERC20: null,
      symbolERC20: null,
      decimalsERC20: null,
      balanceERC20: null,
    };
  }

  componentDidMount = async () => {
    try {
      Logger.log("get web3");
      // Get network provider and web3 instance.
      const web3 = await getWeb3();
      Logger.log("web3", web3);

      // Use web3 to get the user's accounts.
      const accounts = await web3.eth.getAccounts();
      const activeAccount = accounts[0];
      Logger.log('activeAccount: ', activeAccount);

      // Set web3, accounts, and contract to the state, and then proceed with an
      // example of interacting with the contract's methods.
      this.setState({web3, accounts, activeAccount});

      // Get the contract instance.
      await this.loadContracts();

      // Load out ERC20 token info.
      await this.loadERC20Info();

      await this.watchEvents();

      const thisContext = this;
      if (window.ethereum) {
        window.ethereum.on('accountsChanged', function () {
          Logger.log("accountsChanged");
          web3.eth.getAccounts(function (error, accounts) {
            const activeAccount = accounts[0];
            thisContext.setState({accounts, activeAccount});
          });
        });

        window.ethereum.on('networkChanged', function (netId) {
          Logger.log('networkChanged: ', netId);
          thisContext.loadContracts();
        });
      }
    } catch (error) {
      // Catch any errors for any of the above operations.
      // alert(
      //   `Failed to load web3, accounts, or contract. Check console for details.`,
      // );
      this.setState({showAlert: true});
      Logger.error(error);
    }
  };

  loadContracts = async () => {
    const {web3} = this.state;
    // Logger.log("web3: ", web3);

    if (web3) {
      try {
        const networkId = await web3.eth.net.getId();
        Logger.log("networkId: ", networkId);

        const deployedNetworkcontractNiftyEggsFarmer = NiftyEggsFarmer.networks[networkId];
        Logger.log("deployedNetworkcontractNiftyEggsFarmer: ", deployedNetworkcontractNiftyEggsFarmer);
        const contractNiftyEggsFarmer = new web3.eth.Contract(
          NiftyEggsFarmer.abi,
          deployedNetworkcontractNiftyEggsFarmer && deployedNetworkcontractNiftyEggsFarmer.address,
        );
        Logger.log("contractNiftyEggsFarmer: ", contractNiftyEggsFarmer);

        const deployedNetworkNiftyEggsERC721 = NiftyEggsERC721.networks[networkId];
        Logger.log("deployedNetworkNiftyEggsERC721: ", deployedNetworkNiftyEggsERC721);
        const contractNiftyEggsERC721 = new web3.eth.Contract(
          NiftyEggsERC721.abi,
          deployedNetworkNiftyEggsERC721 && deployedNetworkNiftyEggsERC721.address,
        );
        Logger.log("contractNiftyEggsERC721: ", contractNiftyEggsERC721);

        const deployedNetworkNiftyEggsERC20 = NiftyEggsERC20.networks[networkId];
        Logger.log("deployedNetworkNiftyEggsERC20: ", deployedNetworkNiftyEggsERC20);
        const contractNiftyEggsERC20 = new web3.eth.Contract(
          NiftyEggsERC20.abi,
          deployedNetworkNiftyEggsERC20 && deployedNetworkNiftyEggsERC20.address,
        );
        Logger.log("contractNiftyEggsERC20: ", contractNiftyEggsERC20);

        const deployedNetworkFaucet = Faucet.networks[networkId];
        Logger.log("deployedNetworkFaucet: ", deployedNetworkFaucet);
        const contractFaucet = new web3.eth.Contract(
          Faucet.abi,
          deployedNetworkFaucet && deployedNetworkFaucet.address,
        );
        Logger.log("contractFaucet: ", contractFaucet);

        if (!deployedNetworkNiftyEggsERC721 || !deployedNetworkNiftyEggsERC20 || !deployedNetworkcontractNiftyEggsFarmer) {
          this.setState({showAlert: true});
          return;
        }

        this.setState({
          showAlert: false,
          networkId,
          contractNiftyEggsFarmer,
          contractNiftyEggsERC721,
          contractNiftyEggsERC20,
          contractFaucet
        });
      } catch (error) {
        this.setState({showAlert: true});
        Logger.error(error);
      }
    }
  };

  loadERC20Info = async () => {
    const {activeAccount, contractNiftyEggsERC20} = this.state;

    if (activeAccount && contractNiftyEggsERC20) {
      const nameERC20 = await contractNiftyEggsERC20.methods.name().call();
      const symbolERC20 = await contractNiftyEggsERC20.methods.symbol().call();
      const decimalsERC20 = await contractNiftyEggsERC20.methods.decimals().call();
      const balanceERC20 = await contractNiftyEggsERC20.methods.balanceOf(activeAccount).call();

      this.setState({nameERC20, symbolERC20, decimalsERC20, balanceERC20});
    }
  };

  watchEvents = async () => {
    const {activeAccount, contractNiftyEggsERC20} = this.state;
    const thisContext = this;

    if (activeAccount && contractNiftyEggsERC20) {
      contractNiftyEggsERC20.events.Transfer({
        fromBlock: 'latest'
      }).on('data', function (event) {
        const params = event.returnValues;
        if (params.from === activeAccount || params.to === activeAccount) {
          Logger.log("Transfer event", event);
          thisContext.loadERC20Info();
        }
      }).on('error', Logger.error);
    }
  };

  render() {
    const {
      showAlert,
      web3, accounts, activeAccount, networkId,
      contractNiftyEggsFarmer, contractNiftyEggsERC721, contractNiftyEggsERC20, contractFaucet,
      nameERC20, symbolERC20, decimalsERC20, balanceERC20
    } = this.state;

    return (
      <div className="App">
        <Web3Context.Provider value={{web3, accounts, activeAccount, networkId}}>
          <ContractsContext.Provider value={{
            contractNiftyEggsFarmer,
            contractNiftyEggsERC721,
            contractNiftyEggsERC20,
            contractFaucet,
            nameERC20,
            symbolERC20,
            decimalsERC20,
            balanceERC20
          }}>
            <Router>
              <NavBar/>
              {
                showAlert ? <AlertDismissible onClose={() => this.setState({showAlert: false})}/> : null
              }
              <div className="content">
                <ToastProvider placement='bottom-left' autoDismiss={true} autoDismissTimeout={10000}>
                  <Switch>
                    <Route exact path="/">
                      <Home/>
                    </Route>
                    <Route path="/events">
                      <Events/>
                    </Route>
                    <Route path="/farm">
                      <Farm/>
                    </Route>
                    <Route path="/inventory">
                      <MyNFTs/>
                    </Route>
                    <Route path="/create">
                      <Create/>
                    </Route>
                    <Route component={NotFound}/>
                  </Switch>
                </ToastProvider>
              </div>
              <Footer/>
            </Router>
          </ContractsContext.Provider>
        </Web3Context.Provider>
      </div>
    );
  }
}

export default App;
